import TypographyBold from './typography-bold';

export default TypographyBold;
